import { useEffect, useState } from "react";
import { publicApiCall } from "src/api/axiosClient/userApi";
import { storePendingSsoDestination } from "src/services/loginEntry";

type SsoDanceState = {
    loading: boolean;
    error: string | null;
};

const IDLE: SsoDanceState = { loading: false, error: null };

export const useSsoDance = () => {
    const [{ loading, error }, setUI] = useState<SsoDanceState>(IDLE);

    useEffect(() => {
        const resumeFromHistory = (event: PageTransitionEvent) => {
            if (event.persisted) setUI(IDLE);
        };

        window.addEventListener("pageshow", resumeFromHistory);
        return () => window.removeEventListener("pageshow", resumeFromHistory);
    }, []);

    const getAuthorizedUrl = async (authorizationUrl: string, providerName: string) => {
        const response = await publicApiCall.get(authorizationUrl + encodeURIComponent(providerName));
        if (response.data.authorizationUrl) {
            return response.data.authorizationUrl;
        } else {
            return null;
        }
    };

    const getAuth = async (authorizationUrl: string, providerName: string, destination?: string | null) => {
        setUI({ loading: true, error: null });

        const authorizedUrl = await getAuthorizedUrl(authorizationUrl, providerName).catch(() => null);
        if (authorizedUrl === null) {
            setUI({ loading: false, error: "error" });
            return;
        }

        storePendingSsoDestination(destination);
        window.location.assign(authorizedUrl);
    };

    return { loading, error, getAuth };
};
